import React, { useState } from "react";
// import { BlurView } from "@react-native-community/blur";
import {
  View,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  ImageURISource,
  Image,
  Text,
  Dimensions,
} from "react-native";
import ModalComponentForDown from "../ModelComponentForDown";
import FeedIcons from "../../assets/Icons/FeedIcons";
import PreviewProfile from "../../screens/UserProfile/components/PreviewProfile";
import ModalComponent from "../ModalComponent";
import { BlurView } from "expo-blur";

interface SelectCountryProps {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;
  data: any;
}

export default function PreviewModal({
  isDialog = false,
  isVisible,
  toggleModal,
  data,
}: SelectCountryProps) {

  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <BlurView
        intensity={20}
        style={{
          flex: 1,
          zIndex: 1,
        }}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalWrap}>
            <View style={styles.PreiewModalContainer}>
              <PreviewProfile toggleModal={toggleModal} data={data} />
            </View>
          </View>
        </View>
      </BlurView>
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: "rgba(169, 169, 169, 0.60)",
    flex: 1,
  },
  modalWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    height: "100%",
  },
  PreiewModalContainer: {
    width: "100%",
    height: Dimensions.get("window").height * 0.9,
    position: "absolute",
    bottom: 0,
  },
});
